export default __webpack_public_path__ + "static/media/about5title1.824408e5.png";